(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class StickyHeader extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {

    this.section = this.closest('.shopify-section');

    this.alwaysSticky = this.getAttribute('data-sticky-type') === 'always';

    this.bounds = {};

    this.currentScrollTop = 0;

    this.setHeaderHeight();

    this.scrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.scrollHandler, false);

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.resizeObserver.observe(this);
    } else {
      window.addEventListener('resize', () => this.setHeaderHeight());
    }

    if (this.alwaysSticky && this.section) {
      this.section.classList.add('shopify-section-header-sticky');
    }

    this.createObserver();

  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.scrollHandler);
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  createObserver() {

    const observer = new IntersectionObserver((entries) => {
      this.bounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this);

  }

  onScroll() {

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.alwaysSticky) {

      if (scrollTop > 2) {
        this.classList.add('is-sticky-active');
      } else {
        this.classList.remove('is-sticky-active');
      }

      this.currentScrollTop = scrollTop;

      return;

    }

    if (!this.section) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.bounds.bottom) {

      this.section.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
      this.classList.add('is-sticky-active');

    } else if (scrollTop < this.currentScrollTop && scrollTop > this.bounds.bottom) {

      this.section.classList.add('shopify-section-header-sticky', 'animate');
      this.section.classList.remove('shopify-section-header-hidden');
      this.classList.add('is-sticky-active');

    } else if (scrollTop <= this.bounds.top) {

      this.section.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.classList.remove('is-sticky-active');

    }

    this.currentScrollTop = scrollTop;

  }

}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}


/* ============================================================
   MOBILE MENU
   Close the main drawer after a real navigation link is clicked.
   Nested <summary> elements continue to work normally.
   ============================================================ */

document.addEventListener('click', (event) => {

  const clickedLink = event.target.closest('.dwell-mobile-menu__drawer a');

  if (!clickedLink) return;

  const mobileMenu = clickedLink.closest('.dwell-mobile-menu');

  if (mobileMenu) {
    mobileMenu.removeAttribute('open');
  }

});

/* Keep one sibling category open at each level of the mobile menu.
   Delegation also supports headers reloaded by the theme editor. */
document.addEventListener('click', (event) => {
  const summary = event.target.closest('.dwell-mobile-menu__submenu > summary');
  if (!summary) return;

  const submenu = summary.parentElement;
  const mobileMenu = submenu.closest('.dwell-mobile-menu');
  if (!mobileMenu || !mobileMenu.getClientRects().length || submenu.open) return;

  const list = submenu.closest('ul');
  if (!list) return;

  list.querySelectorAll('.dwell-mobile-menu__submenu[open]').forEach((other) => {
    if (other !== submenu && other.closest('ul') === list) {
      other.open = false;
      other.querySelectorAll('.dwell-mobile-menu__submenu[open]').forEach((nested) => {
        nested.open = false;
      });
    }
  });
});


  } catch(e) { console.error(e); }
})();
})();
